import type { DinhDangChiSo } from '@qlk/shared';

import { dinhDangRpm, dinhDangTienGon } from '../../../../ui/Money.js';
import { gonSo, phanTram, thoiLuong } from '../dinhDang.js';

/**
 * Định dạng một giá trị theo `DinhDangChiSo` của trang Hiệu suất.
 *
 * Khác `TheChiSo.dinhDangGiaTri` ở hai chỗ, và đó là lý do nó tồn tại riêng:
 * `'gio'` ở đây nhận **giờ** (máy chủ đã chia 60) chứ không nhận phút, và có
 * thêm `'rpm'`. Dùng chung hàm kia thì giờ xem bị chia 60 lần thứ hai.
 *
 * `null` luôn ra `—`: không bao giờ in `0` thay cho "chưa có số liệu".
 */
export function dinhDangChiSo(
  giaTri: number | null,
  dinhDang: DinhDangChiSo,
  currency = 'USD',
): string {
  if (giaTri === null) return '—';

  switch (dinhDang) {
    case 'gio':
      return gonSo(giaTri);
    case 'tien':
      return dinhDangTienGon(giaTri);
    case 'rpm':
      return dinhDangRpm(giaTri, currency);
    case 'phan-tram':
      return phanTram(giaTri);
    case 'thoi-luong':
      return thoiLuong(giaTri);
    default:
      return gonSo(giaTri);
  }
}

/**
 * Chênh lệch giữa hai kỳ, đã mang đơn vị.
 *
 * Chỉ số so bằng **điểm phần trăm** (CTR) in `1,2 điểm`; còn lại in phần trăm
 * tương đối. Trả `—` khi không so được — chứ không `0 %`, vì `0 %` đọc ra là
 * "y nguyên".
 */
export function nhanChenh(delta: number | null, pct: number | null, soTheoDiem: boolean): string {
  if (soTheoDiem) {
    return delta === null ? '—' : `${phanTram(Math.abs(delta), 1).replace('%', '')} điểm`;
  }
  return pct === null ? '—' : phanTram(Math.abs(pct));
}
